// validationUtils.js
export function hasLowerCase(str) {
    return (/[a-z]/.test(str));
  }
  
  export function hasUpperCase(str) {
    return (/[A-Z]/.test(str));
  }
  
  export function hasNumeric(str) {
    return (/[0-9]/.test(str));
  }
  
  export function hasNonAlphanumeric(str) {
    return (/[^a-zA-Z0-9]/g).test(str);
  }
  
  export function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  
  export function showInputErrorMessage(element, message) {
    element.after("<div class=\"input-error\">" + message + "</div>");
  }
  
  export function hideInputErrorMessage(element) {
    element.next().remove();
  }
  